<template>
  <div id="artist-profile">
    <!-- PROFILE HEADER -->
    <section class="profile-header">
      <img
        v-if="photos.length && photos[0].url_path"
        :src="photos[0].url_path"
        class="cover"
        alt="featured-background"
      />
      <div class="col-12 d-flex flex-column align-items-center text-center">
        <div class="avatar-wrapper">
          <content-loader
            v-if="!profile_image"
            :height="150"
            :width="150"
            :speed="2"
            primaryColor="#f3f3f3"
            secondaryColor="#ecebeb"
          >
            <circle cx="75" cy="75" r="75" />
          </content-loader>
          <img
            v-else
            :src="profile_image"
            class="artist-avatar rounded-circle"
            :alt="'Avatar ' + handle"
          />
        </div>
        <div class="d-flex align-items-center handle-wrapper">
          <h1 class="artist-name display-3 text-white ellipsis">
            {{ handle.substring(1) }}
          </h1>
          <div class="artist-name">
            <verified-badge v-if="is_verified" />
          </div>
        </div>

        <follow-button class="mt-2" :artist_id="artist_id" type="default" />
      </div>
    </section>

    <!-- <section class="badges-section" v-if="is_featured || is_top_seller">
      <div class="container">
        <div class="row">
          <div class="col-12 text-center">
            <div v-if="is_featured" class="bg-gradient-info featured-badge">
              <i class="fas fa-star mr-1"></i> FEATURED ARTIST
            </div>
          </div>
        </div>
      </div>
    </section> -->
    <section class="badges-section" v-if="is_verified || is_featured">
      <div class="container">
        <div class="row">
          <div class="col-12 text-center badges-col">
            <div v-if="is_verified" class="bg-gradient-info featured-badge">
              VERIFIED
            </div>
            <div
              v-if="is_visual_spirits"
              class="visual-spirits-badge featured-badge"
            >
              VISUAL SPIRITS
            </div>
            <div v-if="is_featured" class="bg-gradient-danger featured-badge">
              FEATURED
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- ARTIST BIO -->
    <section v-if="bio || instagram" class="artist-bio">
      <div class="container">
        <div class="row">
          <div
            v-if="bio"
            class="col-lg-8 offset-lg-2 text-center mb-lg-2 bio-text"
          >
            {{ bio }}
          </div>
          <div
            v-if="instagram"
            class="col-lg-8 offset-lg-2 text-center mt-4 mb-lg-2 instagram-link"
          >
            <a
              :href="'https://instagram.com/' + instagram + '/'"
              target="_blank"
              ><i class="fab fa-instagram mr-1"></i
              ><strong>{{ instagram }}</strong></a
            >
          </div>
        </div>
      </div>
    </section>

    <!-- AVAILABLE ARTWORK -->
    <section class="available-artwork">
      <div class="container">
        <!-- <div class="row">
          <div class="col-lg-8 offset-lg-2 text-center mb-3">
            <section-header
              title="Available Artwork"
              subtitle="Original and Exclusive"
            />
            <small class="available-disclaimer"
              >Each artwork is exclusive and can only be purchased once and will
              not be available on the site after purchase. If you have your eye
              on a particular piece, we recommend grabbing it while you
              can.</small
            >
          </div>
        </div> -->
        <div class="row mt-6" v-if="loading">
          <div
            v-for="n in 12"
            :key="'artist-artwork-' + n"
            class="col-md-3 col-6"
          >
            <artwork-card :placeholder="true" />
          </div>
        </div>
        <div v-else>
          <div
            v-if="photos.length || animations.length"
            class="row artwork-section-header mt-4"
          >
            <div
              id="artwork-content"
              class="artwork-section-content col-12 d-flex justify-content-start align-items-center"
            >
              <base-button
                size="md"
                :type="selectedTab === 'images' ? 'primary' : 'outline-primary'"
                @click="toggleImages"
                >IMAGES ({{ photoTotal }})</base-button
              >
              <base-button
                size="md"
                :type="
                  selectedTab === 'animations' ? 'primary' : 'outline-primary'
                "
                @click="toggleAnimations"
                >ANIMATIONS ({{ animTotal }})</base-button
              >
            </div>
          </div>
          <div v-if="showAnimations && selectedTab === 'animations'">
            <div v-if="animations.length > 0" class="row">
              <div
                v-for="animation in animations"
                :key="animation.artist_handle + '-animation-' + animation.id"
                class="col-md-3 col-6"
              >
                <artwork-card
                  :username="animation.artist_handle"
                  :thumbnail="animation.url_path"
                  :artworkId="animation.id"
                  :poster="animation.poster_url_path"
                  type="animation"
                  :price="animation.price"
                  :showUsername="false"
                />
              </div>
              <!-- <div class="row w-100">
                <div class="col-12 text-center">
                  <base-button
                    class="mb-4"
                    v-if="animations.length > animationsToShow"
                    type="outline-primary"
                    size="sm"
                    @click="showMoreAnimations"
                    >SHOW MORE</base-button
                  >
                  <base-button
                    class="mb-4"
                    v-if="
                      animations.length > 24 &&
                      animationsToShow >= animations.length
                    "
                    type="outline-primary"
                    size="sm"
                    @click="showLessAnimations"
                    >SHOW LESS</base-button
                  >
                </div>
              </div> -->
            </div>
            <div v-else class="row">
              <div
                class="col-12 text-center d-flex flex-column no-artwork px-5"
              >
                <i class="far fa-frown-open"></i>Sorry, this artist does not
                have any available animations at this time.
              </div>
            </div>
          </div>
          <div v-if="showImages && selectedTab === 'images'">
            <div v-if="photos.length > 0" class="row">
              <div
                v-for="artwork in photos"
                :key="artwork.artist_handle + '-artwork-' + artwork.id"
                class="col-md-3 col-6"
              >
                <artwork-card
                  :username="artwork.artist_handle"
                  :thumbnail="artwork.url_path"
                  :artworkId="artwork.id"
                  :proFile="artwork.pro_file_id ? true : false"
                  :price="artwork.price"
                  :proFilePrice="artwork.pro_file_price"
                  :proFileOnly="artwork.pro_file_only === '1' ? true : false"
                  :showUsername="false"
                />
              </div>
              <!-- <div class="row w-100">
                <div class="col-12 text-center">
                  <base-button
                    class="mb-4"
                    v-if="photos.length > artworkToShow"
                    type="outline-primary"
                    size="sm"
                    @click="showMoreArtwork"
                    >SHOW MORE</base-button
                  >
                  <base-button
                    class="mb-4"
                    v-if="photos.length > 52 && artworkToShow >= photos.length"
                    type="outline-primary"
                    size="sm"
                    @click="showLessArtwork"
                    >SHOW LESS</base-button
                  >
                </div>
              </div> -->
            </div>
            <div v-else class="row">
              <div
                class="col-12 text-center d-flex flex-column no-artwork px-5"
              >
                <i class="far fa-frown-open"></i>Sorry, this artist does not
                have any available images at this time.
              </div>
            </div>
          </div>
          <div
            v-if="
              (selectedTab === 'images' && photoTotal > 0) ||
              (selectedTab === 'animations' && animTotal > 0)
            "
          >
            <base-pagination
              class="mt-2"
              :page-count="
                pageCount(selectedTab === 'images' ? photoTotal : animTotal)
              "
              v-model="page"
              align="center"
              @pageChange="pageChange"
            ></base-pagination>
          </div>
        </div>
      </div>
    </section>

    <!-- Platforms -->
    <platforms />

    <!-- FAQ CTA -->
    <call-to-action-section
      text="Have questions about how you can use licensed artwork? Check out our FAQ."
      class="bg-gradient-info"
    >
      <router-link to="/about" class="btn btn-secondary"
        >FREQUENTLY ASKED QUESTIONS</router-link
      >
    </call-to-action-section>
  </div>
</template>

<script>
import { ContentLoader } from "vue-content-loader";
import { mapState } from "vuex";
import {
  SectionHeader,
  ArtworkCard,
  CallToActionSection,
  FollowButton,
  Platforms,
  VerifiedBadge,
} from "../../components";

const apiBaseURL = process.env.VUE_APP_API_URL;
const artgrabURL = process.env.VUE_APP_ARTGRAB_URL;

export default {
  name: "artist-profile-page",
  metaInfo() {
    const urlPath = this.getMetaUrlPath();
    return {
      title: `Download Artwork and Animations by ${this.handle.substring(
        1
      )} - Art Grab`,
      meta: [
        {
          vmid: "description",
          name: "description",
          content: this.meta
            ? this.meta.slice(0, 159)
            : `Exclusively license artwork by ${this.handle} on Art Grab. Use it for album covers, posters, or anything you like.`,
        },
        {
          vmid: "twitter:title",
          name: "twitter:title",
          content: `${this.handle} on Art Grab`,
        },
        {
          vmid: "twitter:description",
          name: "twitter:description",
          content: `Exclusively license artwork by ${this.handle} on Art Grab. Use it for album covers, posters, or anything you like.`,
        },
        { vmid: "twitter:image", name: "twitter:image", content: urlPath },
        {
          vmid: "og:url",
          property: "og:url",
          content: `${artgrabURL}/art/${this.handle.substring(1)}`,
        },
        {
          vmid: "og:title",
          property: "og:title",
          content: `${this.handle} on Art Grab`,
        },
        {
          vmid: "og:description",
          property: "og:description",
          content: `Exclusively license artwork by ${this.handle} on Art Grab. Use it for album covers, posters, or anything you like.`,
        },
        { vmid: "og:image", property: "og:image", content: urlPath },
        { vmid: "og:type", property: "og:type", content: "profile" },
      ],
      link: [
        {
          rel: "canonical",
          href: `${artgrabURL}/art/${this.handle.substring(1)}`,
        },
      ],
    };
  },
  data() {
    return {
      handle: " ",
      profile_image: "",
      bio: "",
      meta: "",
      fullName: "",
      photos: [],
      artists: [],
      loading: false,
      is_featured: false,
      is_verified: false,
      is_top_seller: false,
      is_visual_spirits: false,
      artist_id: null,
      followLoading: false,
      animations: [],
      view: "images",
      // artworkToShow: 52,
      // animationsToShow: 24,
      showImages: true,
      showAnimations: true,
      instagram: "",
      selectedTab: "images",
      photoTotal: 0,
      animTotal: 0,
      page: 1,
    };
  },
  components: {
    ContentLoader,
    // SectionHeader,
    ArtworkCard,
    CallToActionSection,
    FollowButton,
    Platforms,
    VerifiedBadge,
  },
  computed: {
    ...mapState(["user", "isLoggedIn"]),
    followOrUnfollow() {
      return this.isFollowing();
    },
  },
  methods: {
    pageCount(total) {
      return Math.ceil(total / 100);
    },
    pageChange() {
      this.scrollToElement("artwork-content");
      this.getArtworkData();
    },
    scrollToElement: function (element_id) {
      var bodyRect = document.body.getBoundingClientRect();
      var elemRect = document
        .getElementById(element_id)
        .getBoundingClientRect();
      var offset = elemRect.top - bodyRect.top;

      window.scrollTo({
        left: 0,
        top: offset - 140,
        behavior: "smooth",
      });
    },
    toggleAnimations() {
      this.selectedTab = "animations";
      this.showImages = false;
      this.showAnimations = true;
      this.page = 1;
      this.getArtworkData();
    },
    toggleImages() {
      this.selectedTab = "images";
      this.showAnimations = false;
      this.showImages = true;
      this.page = 1;
      this.getArtworkData();
    },
    // showMoreArtwork() {
    //   let currNum = this.artworkToShow;
    //   if (this.artworkToShow < this.photos.length) {
    //     currNum += 52;
    //     if (currNum >= this.photos.length) {
    //       this.artworkToShow = this.photos.length;
    //     } else {
    //       this.artworkToShow = currNum;
    //     }
    //   }
    // },
    // showLessArtwork() {
    //   this.artworkToShow = 52;
    // },
    // showMoreAnimations() {
    //   let currNum = this.animationsToShow;
    //   if (this.animationsToShow < this.animations.length) {
    //     currNum += 24;
    //     if (currNum >= this.animations.length) {
    //       this.animationsToShow = this.animations.length;
    //     } else {
    //       this.animationsToShow = currNum;
    //     }
    //   }
    // },
    // showLessAnimations() {
    //   this.animationsToShow = 24;
    // },
    getMetaUrlPath() {
      if (this.photos.length > 0) {
        return this.photos[0].url_path;
      }
      return "https://i.imgur.com/gp9AfzO.jpeg";
    },
    isFollowing() {
      if (this.isLoggedIn) {
        return (
          this.user.following.filter(
            (artist) => artist.artist_id == this.artist_id
          ).length > 0
        );
      }
      return false;
    },
    handleFollow() {
      if (this.isLoggedIn) {
        this.followLoading = true;
        this.axios
          .post(`${apiBaseURL}/api/artv1.1/user/followartist`, {
            artist_id: this.artist_id,
            unfollow: this.isFollowing(),
          })
          .then((result) => {
            if (result.data.message === "Success") {
              if (result.data.data.message === "Success") {
                this.$store.commit("setFollowing", result.data.data.following);
              }
            }
          })
          .catch((error) => {
            /*eslint no-console: ["error", { allow: ["warn", "error"] }] */
            console.error(error);
          })
          .finally(() => {
            this.followLoading = false;
          });
      } else {
        this.$store.commit("showLoginModal", true);
      }
    },
    getArtworkData() {
      this.axios
        .post(`${apiBaseURL}/api/artv1.1/photo/artistprofile`, {
          handle: this.$route.params.artist,
          offset: (this.page - 1) * 100,
        })
        .then((result) => {
          if (!result.data.data.profile_image) {
            this.$router.push({ path: "/notfound" });
          } else {
            this.handle = result.data.data.handle;
            this.profile_image = `${process.env.VUE_APP_CDN_BASE_URL}${result.data.data.profile_image}`;
            this.bio = result.data.data.bio;
            this.instagram = result.data.data.instagram;
            this.meta = result.data.data.meta || result.data.data.bio;
            this.is_featured =
              result.data.data.is_featured === "1" ? true : false;
            this.is_verified =
              result.data.data.is_verified === "1" ? true : false;
            this.is_visual_spirits =
              result.data.data.is_visual_spirits === "1" ? true : false;
            this.is_top_seller =
              result.data.data.is_top_seller === "1" ? true : false;
            this.artist_id = result.data.data.artist_id;
            if (
              this.profile_image.substring(this.profile_image.length - 3) !==
              "jpg"
            ) {
              this.profile_image = "";
            }
            this.photoTotal = result.data.data.photo_total;
            this.animTotal = result.data.data.anim_total;

            this.photos = result.data.data.photos;
            this.animations = result.data.data.animations;
            this.artists = result.data.data.artists;

            for (var i = 0; i < this.photos.length; i++) {
              this.photos[
                i
              ].url_path = `${process.env.VUE_APP_CDN_BASE_URL}${this.photos[i].url_path}`;
              for (var j = 0; j < this.artists.length; j++) {
                if (this.photos[i].artist_id == this.artists[j].artist_id) {
                  this.photos[i].artist_handle = this.artists[j].handle;
                  this.photos[
                    i
                  ].artist_profile_image = `${process.env.VUE_APP_CDN_BASE_URL}${this.artists[j].profile_image}`;
                  break;
                }
              }
            }
            for (var i = 0; i < this.animations.length; i++) {
              this.animations[
                i
              ].url_path = `${process.env.VUE_APP_ANIMATION_CDN_URL}${this.animations[i].url_path}`;
              this.animations[
                i
              ].poster_url_path = `${process.env.VUE_APP_ANIMATION_CDN_URL}${this.animations[i].poster_url_path}`;
              for (var j = 0; j < this.artists.length; j++) {
                if (this.animations[i].artist_id == this.artists[j].artist_id) {
                  this.animations[i].artist_handle = this.artists[j].handle;
                  this.animations[
                    i
                  ].artist_profile_image = `${process.env.VUE_APP_CDN_BASE_URL}${this.artists[j].profile_image}`;
                  break;
                }
              }
            }
          }
        })
        .catch((error) => {
          /*eslint no-console: ["error", { allow: ["warn", "error"] }] */
          console.error(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  mounted: function () {
    this.$store.commit("setLayout", "page-layout");
  },
  created: function () {
    this.loading = true;
    this.axios
      .post(`${apiBaseURL}/api/artv1.1/photo/artistprofile`, {
        handle: this.$route.params.artist,
        offset: (this.page - 1) * 100,
      })
      .then((result) => {
        if (!result.data.data.profile_image) {
          this.$router.push({ path: "/notfound" });
        } else {
          this.handle = result.data.data.handle;
          this.profile_image = `${process.env.VUE_APP_CDN_BASE_URL}${result.data.data.profile_image}`;
          this.bio = result.data.data.bio;
          this.instagram = result.data.data.instagram;
          this.meta = result.data.data.meta || result.data.data.bio;
          this.is_featured =
            result.data.data.is_featured === "1" ? true : false;
          this.is_verified =
            result.data.data.is_verified === "1" ? true : false;
          this.is_visual_spirits =
            result.data.data.is_visual_spirits === "1" ? true : false;
          this.is_top_seller =
            result.data.data.is_top_seller === "1" ? true : false;
          this.artist_id = result.data.data.artist_id;
          if (
            this.profile_image.substring(this.profile_image.length - 3) !==
            "jpg"
          ) {
            this.profile_image = "";
          }
          this.photoTotal = result.data.data.photo_total;
          this.animTotal = result.data.data.anim_total;

          this.photos = result.data.data.photos;
          this.animations = result.data.data.animations;
          this.artists = result.data.data.artists;

          for (var i = 0; i < this.photos.length; i++) {
            this.photos[
              i
            ].url_path = `${process.env.VUE_APP_CDN_BASE_URL}${this.photos[i].url_path}`;
            for (var j = 0; j < this.artists.length; j++) {
              if (this.photos[i].artist_id == this.artists[j].artist_id) {
                this.photos[i].artist_handle = this.artists[j].handle;
                this.photos[
                  i
                ].artist_profile_image = `${process.env.VUE_APP_CDN_BASE_URL}${this.artists[j].profile_image}`;
                break;
              }
            }
          }
          for (var i = 0; i < this.animations.length; i++) {
            this.animations[
              i
            ].url_path = `${process.env.VUE_APP_ANIMATION_CDN_URL}${this.animations[i].url_path}`;
            this.animations[
              i
            ].poster_url_path = `${process.env.VUE_APP_ANIMATION_CDN_URL}${this.animations[i].poster_url_path}`;
            for (var j = 0; j < this.artists.length; j++) {
              if (this.animations[i].artist_id == this.artists[j].artist_id) {
                this.animations[i].artist_handle = this.artists[j].handle;
                this.animations[
                  i
                ].artist_profile_image = `${process.env.VUE_APP_CDN_BASE_URL}${this.artists[j].profile_image}`;
                break;
              }
            }
          }

          if (this.animations.length > 0 && this.photos.length === 0) {
            this.selectedTab = "animations";
            this.toggleAnimations();
          } else if (this.animations.length === 0 && this.photos.length > 0) {
            this.selectedTab = "images";
          } else if (this.animations.length > 0 && this.photos.length > 0) {
            this.selectedTab = result.data.data.artwork_preference;
            if (result.data.data.artwork_preference === "animations") {
              this.toggleAnimations();
            }
          }
        }
      })
      .catch((error) => {
        /*eslint no-console: ["error", { allow: ["warn", "error"] }] */
        console.error(error);
      })
      .finally(() => {
        this.loading = false;
      });
  },
};
</script>

<style scoped lang="scss">
#artist-profile {
  min-height: 100vh;
}
.handle-wrapper {
  height: 70px;
}
.badges-section {
  margin-top: -14px;
  height: 25px;

  .badges-col {
    height: 25px;
  }

  .featured-badge {
    padding: 4px 12px;
    border-radius: 20px;
    font-size: 0.75rem;
    color: white;
    display: inline;
    margin: 0 2px;
    font-weight: 600;
  }
}
.profile-header {
  background-color: black;
  padding: 9rem 2rem 2.5rem;
  background-size: cover;
  background-position: center center;
  // padding: 12.5rem 1.5rem 12rem;
  // background-color: black;
  position: relative;
  overflow: hidden;

  .cover {
    width: 120%;
    left: -10%;
    top: -20px;
    right: -20px;
    bottom: -20px;
    position: absolute;
    filter: blur(1.5rem);
    height: 120%;
    opacity: 0.75;
    object-fit: cover;
  }

  h2 {
    min-height: 49px;
  }

  .avatar-wrapper {
    svg {
      width: 150px;
      height: 150px;
    }

    .artist-avatar {
      width: 150px;
      height: 150px;
      border: 2px solid white;
      object-fit: cover;
    }
  }

  .ellipsis {
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    display: block;
  }

  .artist-name {
    margin-top: 1rem;
    max-width: 100%;
  }
}

.artist-bio {
  padding: 0 0.75rem 0 0.75rem;

  .bio-text {
    white-space: pre-line;
  }

  .row {
    border-bottom: 1px solid #eee;
    padding-bottom: 1.5rem;
  }
}

.instagram-link {
  a {
    color: black;

    &:hover,
    &:active,
    &:focus {
      color: black;
    }
  }
}

.available-artwork {
  padding: 0.5rem 0 4.5rem;

  .no-artwork {
    padding: 4.5rem 0;
    color: #ccc;

    i {
      font-size: 8rem;
      margin-bottom: 2rem;
    }
  }
}

.artwork-section-header {
  margin-bottom: 20px;
  margin-left: 0;
  margin-right: 0;

  .artwork-section-content {
    padding: 0 0 10px;
    border-bottom: 1px solid #000;
  }
}

@media (max-width: 991.98px) {
  .profile-header {
    padding: 6rem 1rem 2rem;

    h2 {
      font-size: 1.25rem;
      min-height: 28px;
    }

    .avatar-wrapper {
      svg {
        width: 120px;
        height: 120px;
      }

      .artist-avatar {
        width: 120px;
        height: 120px;
      }
    }
  }
  .available-artwork {
    padding: 3.5rem 0;
  }

  .available-disclaimer {
    display: block;
    padding: 0.5rem 0.75rem 0;
  }

  .card-wrapper {
    margin-bottom: 2rem;
  }
}

@media (max-width: 575.98px) {
  .artist-name {
    margin-bottom: 10px;
  }
  .artwork-section-header {
    margin-left: 0;
    margin-right: 0;
  }
}
</style>
